<app-header
    style="width: 100%"
    [clicked]="clickedOutside"
    (changeMegaMenuCondition)="changeMenuCondition($event)"
    (selectedLanguage)="switchLanguageHandler($event)"
></app-header>

<section
    class="sme-new-app tw-pb-[45px] tw-bg-gradient-to-b tw-from-[#FFFBF8] tw-to-[30%] tw-to-[#F9F9F9]"
    (click)="closeMegaMenuCondition(); closeDropdown()"
>
    <div class="sme-container">
        <app-application-stepper
            [value]="value"
            [productName]="productName"
        ></app-application-stepper>
        <mat-divider></mat-divider>
        <!--DESKTOP-->
        <div
            class="tw-hidden xl:tw-flex tw-flex-col tw-items-start tw-gap-[10px] xl:tw-mx-0"
        >
            <div class="tw-flex tw-flex-col tw-gap-[10px] xl:tw-mx-[45px]">
                <span
                    class="tw-font-bold tw-text-[#7B7575] tw-text-lg"
                    *ngIf="productName"
                >
                    {{ "NEW_APPLICATION.YOU_ARE_APPLYING_FOR" | translate }}
                </span>
                <div
                    class="tw-bg-[#E3E8EC] tw-w-auto tw-text-center tw-p-[16px] tw-rounded-[16px]"
                    *ngIf="productName"
                >
                    <span
                        class="md:tw-text-2xl tw-font-semibold tw-text-[#003A70]"
                    >
                        {{ productName }}
                    </span>
                </div>
            </div>
            <h3
                class="md:tw-max-w-[100%] tw-w-[100%] tw-pt-[10%] md:tw-pt-0"
                *ngIf="!productName"
            >
                <span
                    class="tw-font-bold tw-mx-0 md:tw-mx-[70px] xl:tw-mx-0 xl:tw-px-[45px]"
                    >{{
                        "NEW_APPLICATION.FINANCIAL_PRODUCTS" | translate
                    }}</span
                >
            </h3>
        </div>
        <!--DESKTOP-->

        <!--MOBILE-->
        <div
            class="tw-flex xl:tw-hidden tw-grid tw-items-center tw-grid-cols-1 xl:tw-grid-cols-[calc(100%_-_310px),300px] tw-gap-[10px] tw-pt-[40px] md:tw-pt-[10px] md:tw-pb-[10px] tw-mx-0 md:tw-mx-[80px] xl:tw-mx-0 tw-mt-3"
        >
            <div class="tw-flex tw-flex-col tw-gap-[12px]">
                <mat-card
                    class="cardCSS"
                    appearance="outlined"
                    *ngIf="productName"
                >
                    <mat-card-content>
                        <div class="tw-flex tw-flex-col tw-gap-[15px]">
                            <div
                                class="tw-font-[500] tw-text-[#6B6B6B] tw-text-[16px] tw-text-center"
                            >
                                {{
                                    "NEW_APPLICATION.YOU_ARE_APPLYING_FOR"
                                        | translate
                                }}
                            </div>
                            <div
                                class="tw-bg-[#E3E8EC] tw-p-[16px] tw-rounded-[16px] tw-text-center"
                            >
                                <span
                                    class="tw-text-[14px] tw-leading-[16.8px] tw-font-[700] tw-text-[#003A70]"
                                >
                                    {{ productName }}
                                </span>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
                <ngx-slick-carousel
                    class="carousel"
                    #slickModal="slick-carousel"
                    [config]="slideConfig"
                    (afterChange)="afterChange($event)"
                    (beforeChange)="beforeChange($event)"
                >
                    <div
                        ngxSlickItem
                        *ngFor="let i of rightSide; let index = index"
                    >
                        <div
                            class="tw-relative tw-w-full tw-h-auto tw-overflow-hidden tw-rounded-lg md:tw-rounded-2xl"
                        >
                            <mat-card class="cardCSS" appearance="outlined">
                                <mat-card-content>
                                    <div
                                        class="tw-flex tw-flex-col tw-gap-[10px] mat-divider-carousel"
                                    >
                                        <div
                                            class="tw-flex tw-flex-row tw-gap-[14px] tw-mt-[1%] tw-mb-[2%]"
                                        >
                                            <img
                                                *ngIf="index == 0"
                                                class="tw-w-[45px] tw-h-[45px]"
                                                src="/assets/images/preliminary.png"
                                                alt="preliminary"
                                            />
                                            <img
                                                *ngIf="index == 1"
                                                class="tw-w-[45px] tw-h-[45px]"
                                                src="/assets/images/expand_circle_right.png"
                                                alt="expand_circle_right"
                                            />
                                            <img
                                                *ngIf="index == 2"
                                                class="tw-w-[45px] tw-h-[45px]"
                                                src="/assets/images/done.png"
                                                alt="done"
                                            />
                                            <div
                                                class="tw-font-semibold tw-leadng-[21.6px] tw-text-[18px] tw-m-auto"
                                            >
                                                {{ i.title | translate }}
                                            </div>
                                        </div>
                                        <mat-divider
                                            class="small"
                                        ></mat-divider>
                                        <div
                                            class="tw-font-medium tw-leading-[24px] tw-text-[16px] tw-mb-[14px] tw-my-[2%]"
                                        >
                                            {{ i.subtitle | translate }}
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                        </div>
                    </div>
                </ngx-slick-carousel>
            </div>
        </div>
        <!--MOBILE-->

        <div
            class="tw-pt-0 md:tw-pt-[32px] xl:tw-px-[45px] tw-mx-0 md:tw-mx-[70px] xl:tw-mx-0"
            (click)="closeDropdown()"
        >
            <div #formContainer>
                <form
                    [formGroup]="businessInfoForm"
                    (ngSubmit)="onSubmit($event, businessInfoForm.value)"
                    class="tw-flex tw-flex-col tw-gap-0 md:tw-gap-[28px]"
                >
                    <div
                        class="tw-grid tw-grid-cols-1 tw-grid-cols-[180px,calc(100%_-_180px)]- xl:tw-grid-cols-[623px,calc(100%_-_623px)]"
                    >
                        <div
                            class="tw-w-full tw-mt-[24px] md:tw-mt-0"
                            id="scrollableDiv"
                        >
                            <label
                                class="tw-block tw-text-[16px] tw-leading-[24px] tw-text-black tw-font-[500] tw-mb-[20px] md:tw-mb-0"
                                >{{
                                    "NEW_APPLICATION.BUSINESS_INFO" | translate
                                }}</label
                            >
                            <div class="tw-grid tw-gap-[16px] tw-mb-[24px]">
                                <revamp-select-general
                                    class="tw-w-full"
                                    [options]="businessIndustryOptions"
                                    [label]="
                                        'NEW_APPLICATION.BUSINESS_INDUSTRY'
                                            | translate
                                    "
                                    [placeHolder]="'SELECT' | translate"
                                    [currentValue]="businessIndustry"
                                    (selectionChange)="
                                        handleBusinessIndustryOptions($event)
                                    "
                                    (dropdownToggle)="closeAllDropdowns(0)"
                                    [contentUnderline]="false"
                                    [headerUnderline]="false"
                                    [mandatoryField]="true"
                                    [controlName]="'businessIndustry'"
                                    [errors]="
                                        getErrors(
                                            'businessIndustry',
                                            'NEW_APPLICATION.BUSINESS_INDUSTRY'
                                                | translate,
                                            'isSelect'
                                        )
                                    "
                                    [isDropdownOpen]="toggleDropDown[0]"
                                />
                            </div>
                            <div
                                class="tw-grid tw-gap-[28px] md:tw-grid-cols-1 tw-mb-0"
                            >
                                <revamp-select-general
                                    class="tw-w-full"
                                    [options]="numberOfYearsOperationOptions"
                                    [label]="
                                        'NEW_APPLICATION.NUMBER_OF_YEARS_IN_OPERATION'
                                            | translate
                                    "
                                    [placeHolder]="
                                        'NEW_APPLICATION.DROPDOWN_PLACEHOLDER'
                                            | translate
                                    "
                                    [currentValue]="numberOfYearsOperation"
                                    (selectionChange)="
                                        handleNumberOfYearsOperationDetail(
                                            $event
                                        )
                                    "
                                    (dropdownToggle)="closeAllDropdowns(1)"
                                    [contentUnderline]="false"
                                    [headerUnderline]="false"
                                    [mandatoryField]="true"
                                    [controlName]="'yearsOfOperation'"
                                    [errors]="
                                        getErrors(
                                            'yearsOfOperation',
                                            'NEW_APPLICATION.NUMBER_OF_YEARS_IN_OPERATION_ERROR'
                                                | translate,
                                            'isSelect'
                                        )
                                    "
                                    [isDropdownOpen]="toggleDropDown[1]"
                                    [tooltipDataHeading]="{
                                        header: 'BUSINESS_INFO_TOOLTIP.NUMBER_OF_YEARS_IN_OPERATION_TITLE',
                                        content:
                                            'BUSINESS_INFO_TOOLTIP.NUMBER_OF_YEARS_IN_OPERATION_CONTENT'
                                    }"
                                />
                                <revamp-select-general
                                    class="tw-w-full"
                                    [options]="listOfProfitableRecent"
                                    [label]="
                                        'NEW_APPLICATION.PROFIT_RECENT'
                                            | translate
                                    "
                                    [placeHolder]="'SELECT' | translate"
                                    [currentValue]="profitRecentSelected"
                                    (selectionChange)="
                                        onSelectProfitRecent($event)
                                    "
                                    (dropdownToggle)="closeAllDropdowns(2)"
                                    [contentUnderline]="false"
                                    [headerUnderline]="false"
                                    [mandatoryField]="true"
                                    [controlName]="'profitable'"
                                    [backgroundOverride]="
                                        numberOfYearsOperation > 0.6
                                            ? ''
                                            : '!tw-bg-[#f4f2f0]'
                                    "
                                    [errors]="
                                        getErrors(
                                            'profitable',
                                            'NEW_APPLICATION.PROFIT_RECENT'
                                                | translate,
                                            'isSelect'
                                        )
                                    "
                                    [tooltipDataHeading]="{
                                        header: 'BUSINESS_INFO_TOOLTIP.PROFITABILITY_TREND_TITLE',
                                        content:
                                            'BUSINESS_INFO_TOOLTIP.PROFITABILITY_TREND_CONTENT'
                                    }"
                                    [isDropdownOpen]="toggleDropDown[2]"
                                />
                            </div>
                            <div
                                class="tw-grid tw-gap-[28px] md:tw-grid-cols-1 tw-mb-0 tw-mt-[28px]"
                            >
                                <revamp-input-general
                                    class="tw-block tw-w-[100%]"
                                    [mandatoryField]="true"
                                    [label]="
                                        'NEW_APPLICATION.TOTAL_ANUAL_SALES_TURNOVER'
                                            | translate
                                    "
                                    [placeHolder]="'RM'"
                                    [controlName]="'annualSalesTurnover'"
                                    [maxlength]="maxAnnualSales"
                                    (input)="
                                        keyPressNumbers(
                                            $event,
                                            'annualSalesTurnover'
                                        )
                                    "
                                    (paste)="pasteNumberOnly($event)"
                                    [errors]="
                                        getErrors(
                                            'annualSalesTurnover',
                                            'NEW_APPLICATION.TOTAL_ANUAL_SALES_TURNOVER_ERROR'
                                                | translate
                                        )
                                    "
                                    [tooltipDataHeading]="{
                                        header: 'BUSINESS_INFO_TOOLTIP.TOTAL_ANUAL_SALES_TURNOVER_TITLE',
                                        content:
                                            'BUSINESS_INFO_TOOLTIP.TOTAL_ANUAL_SALES_TURNOVER_CONTENT'
                                    }"
                                />
                                <revamp-input-general
                                    *ngIf="businessType == 'SDNBHD'"
                                    class="tw-block tw-w-[100%]"
                                    [mandatoryField]="true"
                                    [headerUnderline]="false"
                                    [label]="
                                        'NEW_APPLICATION.PAID_UP_CAPITAL'
                                            | translate
                                    "
                                    [placeHolder]="'RM'"
                                    [controlName]="'paidUpCapital'"
                                    (input)="
                                        keyPressNumbers($event, 'paidUpCapital')
                                    "
                                    (paste)="pasteNumberOnly($event)"
                                    [errors]="
                                        getErrors(
                                            'paidUpCapital',
                                            'NEW_APPLICATION.PAID_UP_CAPITAL'
                                                | translate
                                        )
                                    "
                                    [tooltipDataHeading]="{
                                        header: 'BUSINESS_INFO_TOOLTIP.PAID_UP_CAPITAL_TITLE',
                                        content:
                                            'BUSINESS_INFO_TOOLTIP.PAID_UP_CAPITAL_CONTENT'
                                    }"
                                    [maxlength]="maxPaidUpCapital"
                                />
                            </div>
                            <div
                                class="tw-grid tw-gap-[28px] md:tw-grid-cols-1 tw-mb-0 tw-mt-[28px]"
                            >
                                <revamp-input-general
                                    class="tw-block tw-w-[100%]"
                                    [mandatoryField]="true"
                                    [label]="'NEW_APPLICATION.PBIT' | translate"
                                    [placeHolder]="'RM'"
                                    [controlName]="'pbit'"
                                    [maxlength]="maxPbit"
                                    (input)="keyPressNumbers($event, 'pbit')"
                                    (paste)="pasteNumberOnly($event)"
                                    [errors]="
                                        getErrors(
                                            'pbit',
                                            'NEW_APPLICATION.PBIT_ERROR'
                                                | translate
                                        )
                                    "
                                    [tooltipDataHeading]="{
                                        header: 'BUSINESS_INFO_TOOLTIP.PBIT_TITLE',
                                        content:
                                            'BUSINESS_INFO_TOOLTIP.PBIT_CONTENT'
                                    }"
                                />
                                <revamp-input-general
                                    class="tw-block tw-w-[100%]"
                                    [mandatoryField]="true"
                                    [label]="
                                        'NEW_APPLICATION.TOTAL_MONTHLY_INSTALLMENT'
                                            | translate
                                    "
                                    [placeHolder]="'RM'"
                                    [controlName]="'monthlyInstallment'"
                                    (input)="
                                        keyPressNumbers(
                                            $event,
                                            'monthlyInstallment'
                                        )
                                    "
                                    (paste)="pasteNumberOnly($event)"
                                    [errors]="
                                        getErrors(
                                            'monthlyInstallment',
                                            'NEW_APPLICATION.TOTAL_MONTHLY_INSTALLMENT_ERROR'
                                                | translate
                                        )
                                    "
                                    [tooltipDataHeading]="{
                                        header: 'BUSINESS_INFO_TOOLTIP.TOTAL_MONTHLY_INSTALLMENT_TITLE',
                                        content:
                                            'BUSINESS_INFO_TOOLTIP.TOTAL_MONTHLY_INSTALLMENT_CONTENT'
                                    }"
                                    [maxlength]="maxMonthlyInstallment"
                                />
                            </div>
                            <div
                                class="tw-grid tw-gap-[28px] md:tw-grid-cols-1 tw-mb-0 tw-mt-[28px]"
                            >
                                <revamp-input-general
                                    class="tw-block tw-w-[100%]"
                                    [mandatoryField]="true"
                                    [label]="
                                        'NEW_APPLICATION.NUMBER_OF_FULL_TIME_EMPLOYEE'
                                            | translate
                                    "
                                    [placeHolder]="0"
                                    [controlName]="'noOfEmployee'"
                                    (input)="keyPressNumbers($event)"
                                    (paste)="pasteNumberOnly($event)"
                                    [errors]="
                                        getErrors(
                                            'noOfEmployee',
                                            'NEW_APPLICATION.NUMBER_OF_FULL_TIME_EMPLOYEE'
                                                | translate
                                        )
                                    "
                                    [tooltipDataHeading]="{
                                        header: 'BUSINESS_INFO_TOOLTIP.NUMBER_OF_FULL_TIME_EMPLOYEE_TITLE',
                                        content:
                                            'BUSINESS_INFO_TOOLTIP.NUMBER_OF_FULL_TIME_EMPLOYEE_CONTENT'
                                    }"
                                    [maxlength]="maxNoOfEmployee"
                                />
                            </div>
                            <label
                                class="tw-block tw-text-[16px] tw-leading-[24px] tw-text-black tw-font-[500] tw-mb-[20px] md:tw-mb-0 tw-mt-[28px]"
                                >{{
                                    "NEW_APPLICATION.IMSME_DETAILS" | translate
                                }}</label
                            >
                            <div
                                class="tw-grid tw-gap-[28px] md:tw-grid-cols-1 tw-mb-0"
                            >
                                <revamp-select-general
                                    class="tw-w-full"
                                    [options]="howDoYouKnowAboutIMSMEOptions"
                                    [label]="
                                        'NEW_APPLICATION.HOW_DO_YOU_KNOW_ABOUT_US'
                                            | translate
                                    "
                                    [placeHolder]="'SELECT' | translate"
                                    [currentValue]="howDoYouKnowAboutIMSME"
                                    (selectionChange)="
                                        handleHowDoYouKnowABoutIMSMEOptions(
                                            $event
                                        )
                                    "
                                    (dropdownToggle)="closeAllDropdowns(3)"
                                    [contentUnderline]="false"
                                    [headerUnderline]="false"
                                    [mandatoryField]="true"
                                    [controlName]="'howDoYouKnowAboutUs'"
                                    [errors]="
                                        getErrors(
                                            'howDoYouKnowAboutUs',
                                            'NEW_APPLICATION.HOW_DO_YOU_KNOW_ABOUT_US_ERROR'
                                                | translate,
                                            'isSelect'
                                        )
                                    "
                                    [isDropdownOpen]="toggleDropDown[3]"
                                />
                            </div>
                            <div
                                class="tw-grid tw-gap-[10px] md:tw-grid-cols-1 tw-text-caption-gray tw-mt-[28px]"
                            >
                                <div
                                    class="tw-flex tw-text-[#7B7575] tw-text-[16px] tw-leading-6"
                                >
                                    {{
                                        "NEW_APPLICATION.PLEASE_SPECIFY"
                                            | translate
                                    }}
                                </div>
                                <textarea
                                    class="borderCss tw-max-[640px] tw-h-[144px] tw-w-full tw-bg-white tw-overflow-auto tw-rounded-3xl tw-pt-3.5 tw-pb-3.5 tw-px-6 +
                                    {{
                                        isFocus == true
                                            ? 'focusedBorderCss tw-text-black'
                                            : ' tw-text-caption-gray' ||
                                              f.comment !== null
                                            ? ' tw-text-black'
                                            : 'tw-text-caption-gray'
                                    }}
                                "
                                    [ngClass]="
                                        isFocus == true
                                            ? 'focusedBorderCss '
                                            : ''
                                    "
                                    placeholder="{{
                                        'PLEASE_DESCRIBE_IN_DETAIL' | translate
                                    }}"
                                    formControlName="comment"
                                    [maxlength]="maxComment"
                                    (focus)="onFocus()"
                                    (blur)="onBlur()"
                                >
                                </textarea>
                            </div>
                        </div>
                        <div
                            class="tw-ml-[80px] tw-mt-[10px] tw-hidden xl:tw-block"
                            id="fixedDiv"
                        >
                            <div
                                class="tw-bg-[#ffffff] borderCss tw-rounded-[24px] tw-py-[28px] tw-px-[40px] tw-flex tw-flex-col tw-gap-[10px] tw-relative tw-top-0 tw-w-[406px]"
                                id="innerFixedDiv"
                            >
                                <div
                                    *ngFor="
                                        let i of rightSide;
                                        let index = index
                                    "
                                    class="tw-flex tw-flex-col tw-gap-[14px]"
                                >
                                    <img
                                        *ngIf="index == 0"
                                        class="tw-w-[45px] tw-h-[45px]"
                                        src="/assets/images/preliminary.png"
                                        alt="preliminary"
                                    />
                                    <img
                                        *ngIf="index == 1"
                                        class="tw-w-[45px] tw-h-[45px]"
                                        src="/assets/images/expand_circle_right.png"
                                        alt="expand_circle_right"
                                    />
                                    <img
                                        *ngIf="index == 2"
                                        class="tw-w-[45px] tw-h-[45px]"
                                        src="/assets/images/done.png"
                                        alt="done"
                                    />
                                    <div
                                        class="tw-font-semibold tw-leadng-[21.6px] tw-text-[18px]"
                                    >
                                        {{ i.title | translate }}
                                    </div>
                                    <div
                                        class="tw-font-medium tw-leading-[24px] tw-text-[16px] tw-mb-[14px]"
                                    >
                                        {{ i.subtitle | translate }}
                                    </div>
                                    <mat-divider
                                        *ngIf="index < 2"
                                        style="margin-bottom: 10px"
                                    ></mat-divider>
                                </div>
                            </div>
                        </div>
                    </div>

                    <mat-divider
                        class="dividerDirector"
                        style="margin-bottom: 0 !important"
                    ></mat-divider>
                    <div class="tw-pt-[20px] md:tw-pt-0 tw-block">
                        <span
                            class="tw-block tw-text-[16px] tw-leading-[20px] tw-text-black tw-font-[600] tw-mb-[12px] md:tw-mb-[20px]"
                            >{{
                                "NEW_APPLICATION.TERMS_&_CONDITION" | translate
                            }}</span
                        >
                        <div
                            class="tw-grid tw-gap-[15px] md:tw-gap-[4px] md:tw-grid-cols-1 md:tw-max-w-[735px]"
                        >
                            <div>
                                <div class="tw-py-3 tw-flex">
                                    <input
                                        [attr.ga-event-id]="
                                            prodCode
                                                ? prodCode +
                                                  '_term&condition_1_button_business_information_click'
                                                : 'term&condition_1_button_business_information_click'
                                        "
                                        ga-event-category="Business Information Page Button"
                                        [attr.ga-event-label]="
                                            prodCode
                                                ? prodCode +
                                                  ' Term & Conditions Tick 1 Button Click'
                                                : 'Term & Conditions Tick 1 Button Click'
                                        "
                                        ga-track="track"
                                        formControlName="checkbox_1"
                                        type="checkbox"
                                        class="appearance-none checked:bg-primary-blue tw-w-[18px] tw-h-[18px] tw-me-4 arrow-pointer tw-mt-[3px]"
                                        (click)="closeDropdown()"
                                    />
                                    <span
                                        *ngIf="selectedLanguage == 'bm'"
                                        class="tw-text-[16px] tw-leading-[24px] tw-font-[500] tw-text-[#757575]"
                                    >
                                        Saya telah membaca dan bersetuju dengan
                                        <a
                                            target="_blank"
                                            href="../../../../../assets/documents/terma.pdf"
                                            class="tw-text-[#757575] tw-underline"
                                        >
                                            Terma
                                        </a>
                                        Credit Guarantee Corporation Malaysia
                                        Berhad (CGC) dan (di mana berkenaan)
                                        <a
                                            target="_blank"
                                            href="../../../../../assets/documents/notis_perlindungan_data.pdf"
                                            class="tw-text-[#757575] tw-underline"
                                        >
                                            Notis Perlindungan Data CGC.
                                        </a>
                                    </span>
                                    <span
                                        *ngIf="selectedLanguage == 'en'"
                                        class="tw-text-[16px] tw-leading-[24px] tw-font-[500] tw-text-[#757575]"
                                    >
                                        I have read and agree to the
                                        <a
                                            target="_blank"
                                            href="../../../../../assets/documents/imSME-TnC-EN.pdf"
                                            class="tw-text-[#757575] tw-underline"
                                        >
                                            Terms
                                        </a>
                                        of Credit Guarantee Corporation Malaysia
                                        Berhad (CGC) and (where applicable) CGC
                                        <a
                                            target="_blank"
                                            href="../../../../../assets/documents/notice_of_personal_data_protection.pdf"
                                            class="tw-text-[#757575] tw-underline"
                                        >
                                            Data Protection Notice.
                                        </a>
                                    </span>
                                </div>

                                <div
                                    class="tw-mt-2 tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black"
                                    *ngIf="submitted && f.checkbox_1.errors"
                                >
                                    <mat-icon
                                        class="error-icon !tw-overflow-visible"
                                        >error_outline</mat-icon
                                    >
                                    <span
                                        *ngIf="f.checkbox_1.errors.required"
                                        class="tw-pt-3 tw-pb-3"
                                    >
                                        {{
                                            "NEW_APPLICATION.ACCEPT_TERMS_CONDITIONS"
                                                | translate
                                        }}</span
                                    >
                                </div>
                            </div>
                            <div>
                                <div class="tw-py-3 tw-flex">
                                    <input
                                        [attr.ga-event-id]="
                                            prodCode
                                                ? prodCode +
                                                  '_term&condition_2_button_business_information_click'
                                                : 'term&condition_2_button_business_information_click'
                                        "
                                        ga-event-category="Business Information Page Button"
                                        [attr.ga-event-label]="
                                            prodCode
                                                ? prodCode +
                                                  ' Term & Conditions Tick 2 Button Click'
                                                : 'Term & Conditions Tick 2 Button Click'
                                        "
                                        ga-track="track"
                                        formControlName="checkbox_2"
                                        type="checkbox"
                                        class="appearance-none checked:bg-primary-blue tw-w-[18px] tw-h-[18px] tw-me-4 arrow-pointer tw-mt-[3px]"
                                        (click)="closeDropdown()"
                                    />
                                    <span
                                        class="tw-text-[16px] tw-leading-[24px] tw-font-[500] tw-text-[#757575]"
                                    >
                                        {{
                                            "NEW_APPLICATION.I_HEREBY"
                                                | translate
                                        }}
                                        <a
                                            *ngIf="selectedLanguage == 'bm'"
                                            target="_blank"
                                            href="../../../../../assets/documents/CBM Consent Notice (BM).pdf"
                                            class="tw-text-[#757575] tw-underline"
                                            >{{
                                                "NEW_APPLICATION.NOTICE"
                                                    | translate
                                            }}</a
                                        >
                                        <a
                                            *ngIf="selectedLanguage == 'en'"
                                            target="_blank"
                                            href="../../../../../assets/documents/CBM Consent Notice (EG).pdf"
                                            class="tw-text-[#757575] tw-underline"
                                            >{{
                                                "NEW_APPLICATION.NOTICE"
                                                    | translate
                                            }}</a
                                        >
                                        {{
                                            "NEW_APPLICATION.SUBJECT"
                                                | translate
                                        }}
                                    </span>
                                </div>

                                <div
                                    class="tw-mt-2 tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black"
                                    *ngIf="submitted && f.checkbox_2.errors"
                                >
                                    <mat-icon
                                        class="error-icon !tw-overflow-visible"
                                        >error_outline</mat-icon
                                    >
                                    <span
                                        *ngIf="f.checkbox_2.errors.required"
                                        class="tw-pt-3 tw-pb-3"
                                    >
                                        {{
                                            "NEW_APPLICATION.ACCEPT_TERMS_CONDITIONS"
                                                | translate
                                        }}</span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="tw-hidden md:tw-flex tw-flex-wrap md:tw-flex-row md:tw-justify-end tw-gap-[10px] tw-items-center md:tw-rounded-[80px] tw-py-0 tw-px-0 md:tw-px-[15px] lg:tw-px-[27px]"
                    >
                        <div
                            class="tw-order-3 md:tw-order-2 tw-flex-[0_0_calc(50%_-_5px)] md:tw-flex-[0_0_180px]"
                        >
                            <button
                                [attr.ga-event-id]="
                                    prodCode
                                        ? prodCode +
                                          '_save_as_draft_button_business_information_click'
                                        : 'save_as_draft_button_business_information_click'
                                "
                                ga-event-category="Business Information Page Button"
                                [attr.ga-event-label]="
                                    prodCode
                                        ? prodCode +
                                          ' Save As Draft Main Button Click'
                                        : 'Save As Draft Main Button Click'
                                "
                                ga-track="track"
                                class="tw-text-caption-gray md:tw-max-w-[175px] tw-w-full tw-text-center"
                                type="submit"
                                name="draft"
                                [disabled]="disableSaveDraft"
                            >
                                {{ "SAVE_AS_DRAFT" | translate }}
                            </button>
                        </div>
                        <div
                            class="tw-order-1 md:tw-order-last tw-flex-[0_0_calc(50%_-_5px)] md:tw-flex-[0_0_180px] tw-mb-[10px] md:tw-mb-0"
                        >
                            <button
                                [attr.ga-event-id]="
                                    prodCode
                                        ? prodCode +
                                          '_next_step_application_button_bizp_click'
                                        : 'next_step_application_button_bizp_click'
                                "
                                ga-event-category="Business Information Page Button"
                                [attr.ga-event-label]="
                                    prodCode
                                        ? prodCode +
                                          ' Next Step Application Button Click'
                                        : 'Next Step Application Button Click'
                                "
                                ga-track="track"
                                [disabled]="disableSubmitBtn"
                                class="tw-text-[18px] tw-leading-[20px] md:tw-max-w-[175px] tw-w-full tw-text-center tw-font-[600] tw-rounded-[32px] tw-text-white tw-py-[22px] tw-px-[15px]"
                                [ngClass]="
                                    businessInfoForm.invalid || disableSubmitBtn
                                        ? 'tw-bg-slate-300'
                                        : 'tw-bg-gradient-to-r tw-from-orange-400 tw-to-amber-300'
                                "
                                type="submit"
                                name="next"
                            >
                                {{ "NEXT" | translate }}
                            </button>
                        </div>
                    </div>
                    <div
                        class="tw-flex md:tw-hidden tw-flex-col tw-gap-[10px] tw-items-center tw-py-2 tw-px-0"
                    >
                        <button
                            [attr.ga-event-id]="
                                prodCode
                                    ? prodCode +
                                      '_next_step_application_button_bizp_click'
                                    : 'next_step_application_button_bizp_click'
                            "
                            ga-event-category="Business Information Page Button"
                            [attr.ga-event-label]="
                                prodCode
                                    ? prodCode +
                                      ' Next Step Application Button Click'
                                    : 'Next Step Application Button Click'
                            "
                            ga-track="track"
                            [disabled]="disableSubmitBtn"
                            class="tw-text-[18px] tw-leading-[20px] md:tw-max-w-[175px] tw-w-full tw-text-center tw-font-[600] tw-rounded-[32px] tw-text-white tw-py-[22px] tw-px-[15px]"
                            [ngClass]="
                                businessInfoForm.invalid || disableSubmitBtn
                                    ? 'tw-bg-slate-300'
                                    : 'tw-bg-gradient-to-r tw-from-orange-400 tw-to-amber-300'
                            "
                            type="submit"
                            name="next"
                        >
                            {{ "NEXT" | translate }}
                        </button>
                        <button
                            [attr.ga-event-id]="
                                prodCode
                                    ? prodCode +
                                      '_save_as_draft_button_business_information_click'
                                    : 'save_as_draft_button_business_information_click'
                            "
                            ga-event-category="Business Information Page Button"
                            [attr.ga-event-label]="
                                prodCode
                                    ? prodCode +
                                      ' Save As Draft Main Button Click'
                                    : 'Save As Draft Main Button Click'
                            "
                            ga-track="track"
                            class="tw-text-caption-gray md:tw-max-w-[175px] tw-w-full tw-text-center tw-mt-[5%]"
                            type="submit"
                            name="draft"
                            [disabled]="disableSaveDraft"
                        >
                            {{ "SAVE_AS_DRAFT" | translate }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>
<app-footer
    [selectedLanguage]="selectedLanguage"
    (click)="closeMegaMenuCondition()"
></app-footer>
